import { Multiselect } from '@wizardhealth/stimulus-multiselect'

export default class extends Multiselect {
  connect() {
    super.connect()
  }
}
